import { useMutation, useQuery } from '@apollo/client'

import { gql } from '@/clients/utoniq-core'
import {
  BusinessDetailFragmentDoc,
  BusinessEditMutation,
  BusinessEditMutationVariables,
  ConsoleBusinessEditQuery,
  ConsoleBusinessEditQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { dayjs } from '@/lib/dayjs'
import { getAddressInfoByZipcode } from '@/lib/zipCloud'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { data } = useQuery<
    ConsoleBusinessEditQuery,
    ConsoleBusinessEditQueryVariables
  >(QUERY)
  const [businessEdit] = useMutation<
    BusinessEditMutation,
    BusinessEditMutationVariables
  >(MUTATION)

  return {
    state: {
      artistData: data ?? null,
      artistId: user?.uid ?? '',
    },
    actions: {
      async onSubmit({
        city,
        cityKana,
        line1,
        line1Kana,
        line2,
        line2Kana,
        postalCode,
        state,
        stateKana,
        town,
        townKana,
        birthday,
        ...inputs
      }) {
        await businessEdit({
          variables: {
            updateBusinessInputs: {
              addressKanji: {
                city,
                line1,
                line2,
                postalCode,
                state,
                town,
              },
              addressKana: {
                city: cityKana,
                line1: line1Kana,
                line2: line2Kana,
                postalCode,
                state: stateKana,
                town: townKana,
              },
              birthday: dayjs(birthday).format('YYYY-MM-DD'),
              ...inputs,
            },
          },
        })
      },
      async onGetAddressInfoByCode(postalCode: string) {
        const { results } = await getAddressInfoByZipcode(postalCode)
        return results
      },
    },
  }
})

const QUERY = gql`
  query ConsoleBusinessEdit {
    artist {
      id
      bank {
        id
        accountHolderName
        accountHolderType
        bankName
        last4
        routingNumber
      }
      business {
        ...BusinessDetail
      }
    }
  }
  ${BusinessDetailFragmentDoc}
`
const MUTATION = gql`
  mutation BusinessEdit($updateBusinessInputs: BusinessInput) {
    updateBusiness(inputs: $updateBusinessInputs) {
      id
      business {
        ...BusinessDetail
      }
    }
  }
  ${BusinessDetailFragmentDoc}
`
